module.exports = __webpack_public_path__ + "media/svg/plus-e54a202d.svg";